<template>
    <div id="accordion">
        <div class="card najiz-card-panel mb-3">
            <div class="card-header najiz-panel-header" id="main-details-heading">
                <a class="text-dark" data-toggle="collapse" href="#main-details-collapse" role="button" aria-expanded="false"
                 aria-controls="main-details-collapse">
                    <h4 class="mb-0 py-3">
                        <i class="fal fa-angle-up rotate-icon fa-lg ml-5"></i>
                        <b>
                            1- بيانات العقد
                        </b>
                    </h4>
                </a>
            </div>

            <div id="main-details-collapse" class="collapse show" aria-labelledby="main-details-heading" data-parent="#accordion">
                <div class="card-body" v-if="contractDetails">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-12 cutom-box-shadow" v-if="contractDetails.externalContractCode">
                            <label for="disabledTextInput">رقم العقد المبرم لدى الجهة</label>
                            <p class="mb-0">
                                <b>{{contractDetails.externalContractCode}}</b>
                            </p>
                        </div>

                        <div class="col-lg-4 col-md-4 col-sm-12 cutom-box-shadow" v-if="contractDetails.externalIssueDate">
                            <label for="disabledTextInput">تاريخ إبرام العقد</label>
                            <p class="mb-0">
                                <b>
                                    {{ contractDetails.externalIssueDate | formatGregToHijri }} هـ -
                                    {{ contractDetails.externalIssueDate | getFormattedDate }}م
                                </b>
                            </p>
                        </div>

                        <div class="col-lg-4 col-md-4 col-sm-12 cutom-box-shadow" v-if="contractDetails.contractLocationName">
                            <label for="disabledTextInput">مكان إبرام العقد</label>
                            <p class="mb-0">
                                <b>{{contractDetails.contractLocationName}}</b>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractDetails } from '@/models/contract.model';

    @Component
    export default class ContractMainDetailsComponent extends Vue {
        @Prop({ required: true }) contractDetails!: ContractDetails;
    }
</script>

<style>

    .v-application p {
        margin-bottom: 5px !important;
    }
</style>